import { ParticipantQuoteDto } from '@/features/public/booking/types/BookingQuoteDto.ts';
import { getPricingErrorTypeLabel } from '@/features/public/booking/types/PricingErrorType.utils.ts';

/** Jeden problem wyceny gotowy do pokazania: czyj i na czym polega. */
export interface PricingIssueVm {
  participantLabel: string;
  errorLabel: string;
}

interface ParticipantNameInput {
  firstName?: string;
  lastName?: string;
}

/**
 * Problemy wyceny w kolejności formularza.
 *
 * Wycena wraca zawsze — także dla formularza niekompletnego — a błąd u
 * **dowolnego** uczestnika znaczy, że `paymentPlan` nie powstanie i rezerwacja
 * zostanie odrzucona. Klient ma je zobaczyć tam, gdzie może je naprawić, czyli
 * już na liście uczestników, a nie dopiero w podsumowaniu.
 *
 * Uczestnik bez nazwiska (formularz w trakcie wypełniania) dostaje numer
 * porządkowy — inaczej wiersz zaczynałby się od myślnika.
 */
export const toPricingIssues = (
  participants: ParticipantNameInput[],
  quoted: (ParticipantQuoteDto | undefined)[],
): PricingIssueVm[] =>
  participants.flatMap((participant, index) =>
    (quoted[index]?.errors ?? []).map((error) => ({
      participantLabel:
        `${participant.firstName ?? ''} ${participant.lastName ?? ''}`.trim() ||
        `Uczestnik ${index + 1}`,
      errorLabel: getPricingErrorTypeLabel(error.code),
    })),
  );
